import { ALERT_KEY } from '../../types/alerts.types'

export default {
  [ALERT_KEY]: {
    type: 'success',
    message: '',
  },
}
